/*
 * @Author: tager
 * @Date: 2022-06-09 16:30:36
 * @LastEditors: tager
 * @LastEditTime: 2022-07-01 15:15:19
 * @Description: file content
 */
const defaultDomain =
  location.origin || `${location.protocol}//${location.host}`
const isProduction =
  process.env.NODE_ENV === 'production' &&
  !/localhost|(\d+\.\d+.\d+.\d+)|(dbg\.lizhiweike)/.test(location.hostname)

// 开发配置
const devConfig = {
  MAIN_URL: 'http://dbg.lizhiweike.com',
  BASE_URL: 'http://129.204.145.169:8180',
  // ADMIN_URL: 'http://admin.dev4.weike.fm',
  GATEWAY_URL: 'https://gateway.test.weike.fm',
  GATEWAY_API_URL: 'http://129.204.145.169:8180',
  CONT_MANAGER: 'http://api.dev7.weike.fm/v1/cont_manager',
  AUTH_URL: 'https://dev.open.lizhiweike.com',
  CLIENT_ID: 'weike_fe',
}
const prodConfig = {
  MAIN_URL:
    window.location.origin ||
    `${window.location.protocol}//${window.location.hostname}` ||
    defaultDomain,
  BASE_URL: defaultDomain,
  GATEWAY_URL: 'https://gateway-weike.lizhiweike.com',
  GATEWAY_API_URL: 'https://api-gw.lizhiweike.com',
  CONT_MANAGER: 'http://api.dev7.weike.fm/v1/cont_manager',
  AUTH_URL: 'https://open.lizhiweike.com',
  CLIENT_ID: 'weike_fe',
}

export const basename =
  location.hostname === 'localhost' ? '' : location.pathname.split('/')[1] + '/'

export const Config = isProduction ? prodConfig : devConfig
